export const convertCommaToDot = (count) => {
	const splitCount = count.split(',');
	splitCount[0] = splitCount[0].replace(/\./g, '');
	return splitCount.join('.');
};
